/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import cancelIcon from '../../../../assets/images/Icon-cancel.png';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import CopyContactComponent from './CopyContactComponent';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommonModal from './CommonModal';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import { ShowContractUsingContacts } from './CreateContractModal';
import {
  maintainContractActions,
  handleErrorMessages,
  getExistingCorrLinkIds,
} from '../store/actions';
import { PaperComponent } from '../../../../SharedModules/utilities/utilities';
import { EMAIL_ID_REGEX } from '../../../../SharedModules/AppConstants';

const OtherContact = (props) => {
  const { isEnablebyRole } = props;
  const dispatch = useDispatch();
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState
  );
  const otherContract = useSelector(
    (state) =>
      state.sharedState.ContractReducer.maintainContractState?.otherContract
  );
  const listOfOtherContact = useSelector((state) => {
    return [
      ...new Map(
        state.sharedState.ContractReducer.maintainContractState?.listOfOtherContact?.map(
          (item) => [item.contactTypeCd, item]
        )
      ).values(),
    ];
  });
  const getAllContractData = useSelector(
    (state) => state.sharedState.ContractReducer?.getAllContractData
  );

  const otherContactTab = useSelector((state) => {
    return [
      ...new Map(
        state.sharedState.ContractReducer?.getAllContractData?.otherContactTab?.map(
          (item) => [item.contactTypeCd, item]
        )
      ).values(),
    ];
  });
  const searchContractState = useSelector(
    (state) => state.sharedState.ContractReducer?.searchContractState
  );
  const getContactType = useSelector(
    (state) => state?.sharedState?.ContractReducer?.getContactType
  );
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });

  const [open, setOpen] = React.useState(false);
  const [selectedContact, setSelectedContact] = React.useState(null);
  const [showContractPop, setShowContractPop] = React.useState(false);
  const [showComments, setShowComments] = React.useState(false);
  const [commentShow, setCommentShow] = React.useState(false);
  const [windowWidth, setWindowWidth] = React.useState(window.screen.width);

  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = today.getMonth() + 1; // Months start at 0!
  const dd = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
  const currDate = `${mm}/${dd}/${yyyy}`;
  // const logInUserID = localStorage.getItem('logInUser');
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  // set comment icon on if corrLinkId and comment is available
  const handleExistingCommentList = async () => {
    if (
      maintainContractState.otherContract?.corrLinkId !== null ||
      maintainContractState.otherContract?.corrLinkId !== '' ||
      maintainContractState.otherContract?.corrLinkId !== undefined
    ) {
      const result = await getExistingCorrLinkIds({
        corrLinkId: [maintainContractState.otherContract?.corrLinkId],
      });
      if (result && result.data?.length > 0) {
        result.data.forEach((elem) => {
          if (elem === maintainContractState.otherContract?.corrLinkId) {
            setCommentShow(true);
          }
        });
      } else {
        setCommentShow(false);
      }
    }
  };

  // Set lable text according to the screen width for Phone number
  const textReplace = () => {
    setWindowWidth(window.screen.width);
  };
  React.useEffect(() => {
    window.addEventListener('resize', textReplace);
  }, [windowWidth]);

  React.useEffect(() => {
    handleExistingCommentList();
    if (otherContract?.contactTypeCd === '-1') {
      const data = {
        ...maintainContractState,
        otherContract: {
          ...otherContract,
          contactTypeCd: 'CTR1',
        },
      };
      dispatch(maintainContractActions(data));
    }
  }, []);
  React.useEffect(() => {
    if (showComments) {
      handleExistingCommentList();
    }
  }, [commentsList]);
  // call after onchange event
  const handleOnChangeEvent = (e, name) => {
    const contact = [...listOfOtherContact];
    if (contact && contact?.length > 0) {
      if (name === 'contactTypeCd') {
        contact.map((data) => {
          if (data.contactTypeCd === e.target.value) {
            otherContract.contactTypeCd = data.contactTypeCd || 'CTR1';
            otherContract.contactName = data.contactName || '';
            otherContract.corpName = data.corpName || '';
            otherContract.addrLine1 = data.addrLine1 || '';
            otherContract.addrLine2 = data.addrLine2 || '';
            otherContract.addrLine3 = data.addrLine3 || '';
            otherContract.city = data.city || '';
            otherContract.stateCd = data.stateCd || '';
            otherContract.zip = data.zip || '';
            otherContract.zip4 = data.zip4 || '';
            otherContract.phoneNum = data.phoneNum || '';
            otherContract.phoneExtension = data.phoneExtension || '';
            otherContract.faxNum = data.faxNum || '';
            otherContract.email = data.email || '';
            otherContract.addressChangedInd = data.addressChangedInd || '';
            otherContract.contactSeqNum = data.contactSeqNum || '';
            otherContract.contactTypeCd = data.contactTypeCd || 'CTR1';
            otherContract.copySourceSeqNum = data.copySourceSeqNum || null;
            otherContract.corrLinkId = data.corrLinkId || null;
            otherContract.key =
              searchContractState.contractType == 'onSelect'
                ? getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                    .contractSeqNum
                : maintainContractState.contractSeqNum;
            otherContract.keyTypeCd = 'CONTRACT';
            otherContract.lastUpdateDT = currDate;
            otherContract.lastUpdateUserID = logInUser;
            otherContract.nameChangedInd = data.nameChangedInd || null;
            otherContract.needsAttentionCd = data.needsAttentionCd || null;
          }
          return data;
        });
        const data = {
          ...maintainContractState,
          otherContract: {
            ...otherContract,
            [name]: e.target.value,
          },
        };
        dispatch(maintainContractActions(data));
      } else {
        contact
          .filter((x) => {
            return x.contactTypeCd;
          })
          .map((data) => {
            if (data.contactTypeCd === otherContract.contactTypeCd) {
              data[name] = e.target.value;
            }
            return data;
          });
        const data = {
          ...maintainContractState,
          otherContract: {
            ...otherContract,
            [name]: e.target.value,
          },
          listOfOtherContact: contact,
        };
        dispatch(maintainContractActions(data));
      }
    } else {
      const data = {
        ...maintainContractState,
        otherContract: {
          ...otherContract,
          [name]: e.target.value,
        },
        listOfOtherContact: contact,
      };
      dispatch(maintainContractActions(data));
    }
  };
  // check validation on blur event
  const handleOnBlurEventContactTab = (e, name) => {
    let localErr = errorMessagesFromRedux || [];
    const { value } = e.target;
    let showEmailErr = false;
    let showZip4Err = false;
    let showPhoneErr = false;
    if (name === 'email' && value !== '' && !EMAIL_ID_REGEX.test(value)) {
      localErr = localErr?.filter((item) => item.fieldName !== name);
      localErr.push({
        fieldName: name,
        errorType: 'emailInvalid',
        tabName: 'OtherContact',
        message: constantMessageData.EMAIL_INVALID_FOR_OTHER_CONTRACT_TAB,
        subMessage: constantMessageData.EMAIL_INVALID,
      });
      showEmailErr = true;
    }
    if (name === 'zip4' && value !== '' && value.length <= 3) {
      localErr = localErr?.filter((item) => item.fieldName !== name);
      localErr.push({
        fieldName: name,
        errorType: 'zipRequired',
        tabName: 'OtherContact',
        message: constantMessageData.ZIP4_REQUIRED_FOR_OTHER_CONTRACT_TAB,
        subMessage: constantMessageData.ZIP4_REQUIRED,
      });
      showZip4Err = true;
    }
    if (name === 'phoneNum' && value !== '' && value.length <= 9) {
      localErr = localErr?.filter((item) => item.fieldName !== name);
      localErr.push({
        fieldName: name,
        errorType: 'InvalidPhone',
        tabName: 'OtherContact',
        message: constantMessageData.PHONE_INVALID_ERROR_FOR_OTHER_CONTRACT_TAB,
        subMessage: constantMessageData.PHONE_INVALID_ERROR,
      });
      showPhoneErr = true;
    }
    if (!showEmailErr && !showPhoneErr && !showZip4Err) {
      localErr = localErr?.filter((item) => item.fieldName !== name);
    }
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };
  const copyContract = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const setContactIfNotEmpty = () => {
    if (selectedContact) {
      let contact = listOfOtherContact;
      const newObj = selectedContact;
      let otherCon = otherContract;
      if (contact && contact?.length > 0) {
        contact.map((data) => {
          if (data.contactTypeCd === otherContract.contactTypeCd) {
            otherCon.contactName = selectedContact.contactName || '';
            otherCon.corpName = selectedContact.corpName || '';
            otherCon.addrLine1 = selectedContact.addrLine1 || '';
            otherCon.addrLine2 = selectedContact.addrLine2 || '';
            otherCon.addrLine3 = selectedContact.addrLine3 || '';
            otherCon.city = selectedContact.city || '';
            otherCon.stateCd = selectedContact.stateCd || '';
            otherCon.zip = selectedContact.zip || '';
            otherCon.zip4 = selectedContact.zip4 || '';
            otherCon.phoneNum = selectedContact.phoneNum || '';
            otherCon.phoneExtension = selectedContact.phoneExtension || '';
            otherCon.faxNum = selectedContact.faxNum || '';
            otherCon.email = selectedContact.email || '';
            otherCon.addressChangedInd =
              selectedContact.addressChangedInd || '';
            otherCon.contactSeqNum = null;
            otherCon.copySourceSeqNum =
              selectedContact.copySourceSeqNum || null;
            otherCon.corrLinkId = null;
            otherCon.key =
              searchContractState.contractType == 'onSelect'
                ? getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                    .contractSeqNum
                : maintainContractState.contractSeqNum;
            otherCon.lastUpdateUserID = logInUser;
            otherCon.nameChangedInd = selectedContact.nameChangedInd || null;
            otherCon.needsAttentionCd =
              selectedContact.needsAttentionCd || null;

            data.contactName = selectedContact.contactName || '';
            data.corpName = selectedContact.corpName || '';
            data.addrLine1 = selectedContact.addrLine1 || '';
            data.addrLine2 = selectedContact.addrLine2 || '';
            data.addrLine3 = selectedContact.addrLine3 || '';
            data.city = selectedContact.city || '';
            data.stateCd = selectedContact.stateCd || '';
            data.zip = selectedContact.zip || '';
            data.zip4 = selectedContact.zip4 || '';
            data.phoneNum = selectedContact.phoneNum || '';
            data.phoneExtension = selectedContact.phoneExtension || '';
            data.faxNum = selectedContact.faxNum || '';
            data.email = selectedContact.email || '';
            data.addressChangedInd = selectedContact.addressChangedInd || '';
            data.contactSeqNum = null;
            data.copySourceSeqNum = selectedContact.copySourceSeqNum || null;
            data.corrLinkId = null;
            data.key =
              searchContractState.contractType == 'onSelect'
                ? getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                    .contractSeqNum
                : maintainContractState.contractSeqNum;
            data.keyTypeCd = 'CONTRACT';
            data.lastUpdateDT = `${currDate} 00:00`;
            data.lastUpdateUserID = logInUser;
            data.nameChangedInd = selectedContact.nameChangedInd || null;
            data.needsAttentionCd = selectedContact.needsAttentionCd || null;
          }
        });
      } else {
        otherCon = {
          ...selectedContact,
          corrLinkId: null,
          contactSeqNum: null,
          lastUpdateDT: null,
        };
        contact = {
          ...selectedContact,
          corrLinkId: null,
          contactSeqNum: null,
          lastUpdateDT: null,
        };
      }
      const data = {
        ...maintainContractState,
        otherContract: {
          ...otherCon,
        },
        listOfOtherContact: contact,
      };
      dispatch(maintainContractActions(data));
    }
    handleClose();
  };
  const showContactingContact = () => {
    setShowContractPop(true);
  };
  return (
    <div data-testid='OtherContact-component'>
      <OverlayTrigger
        placement='bottom'
        overlay={<Tooltip id='action-tooltip'>Action</Tooltip>}
      >
        <Dropdown className='icon-dropdown-container frr-lab-diff-action-icon-container'>
          <Dropdown.Toggle
            className='icon-dropdown'
            aria-label='Show Contracts using this Contact'
          >
            <SVGComponent iconName='Icon-export' />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              role='button'
              data-testid='showContracts'
              disabled={searchContractState.contractType !== 'onSelect'}
              onClick={() => {
                if (searchContractState.contractType === 'onSelect') {
                  showContactingContact();
                }
              }}
            >
              Show Contracts using this Contact
            </Dropdown.Item>
            <Dropdown.Item
              role='button'
              data-testid='copyContractData'
              onClick={() => {
                copyContract();
              }}
              disabled={!isEnablebyRole}
            >
              Copy Contact From
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </OverlayTrigger>
      <div className='tab-body'>
        <form autoComplete='off'>
          <div className='my-2 pt-4 frr-other-contacts'>
            <fieldset className='custom-fieldset custom-height'>
              <legend>Contact Information</legend>
              <div className='form-wrapper'>
                <div className='mui-custom-form with-select'>
                  <TextField
                    id='contact_type'
                    data-testid='contact_type'
                    label='Contact Type'
                    fullWidth
                    select
                    placeholder=''
                    inputProps={{ maxLength: 10, id: 'contact_type' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={maintainContractState?.otherContract?.contactTypeCd}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'contactTypeCd');
                    }}
                    disabled={!isEnablebyRole}
                  >
                    {getContactType && getContactType.length > 0
                      ? getContactType.map((item) => {
                          return (
                            <MenuItem
                              key={item.contactTypeCd}
                              value={item.contactTypeCd}
                            >
                              {`${item.contactTypeCd}-${item.shortDescr}`}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
                <div className='mui-custom-form input-md'>
                  <fieldset className='custom-fieldset custom-fieldset-43'>
                    <legend>Existing Contacts</legend>
                    <div className='form-wrapper'>
                      {otherContactTab?.length > 0
                        ? [
                            ...new Set(
                              otherContactTab
                                .filter((x) => {
                                  return x.contactTypeCd;
                                })
                                .map((item, index) => {
                                  return (
                                    <h6>
                                      {item.contactTypeCd}
                                      {otherContactTab.filter((x) => {
                                        return x.contactTypeCd;
                                      }).length ===
                                      index + 1
                                        ? null
                                        : ', '}
                                    </h6>
                                  );
                                })
                            ),
                          ]
                        : null}
                    </div>
                  </fieldset>
                </div>
                <div className='mui-custom-form input-md' />
                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='contactName'
                    label='Name'
                    data-testid='contactName'
                    className='mandate-fields'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 50, id: 'contactName' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={maintainContractState?.otherContract?.contactName}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'contactName');
                    }}
                    disabled={!isEnablebyRole}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='corporationName'
                    label='Corporation Name'
                    data-testid='Corporation-name'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 50, id: 'corporationName' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={maintainContractState?.otherContract?.corpName}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'corpName');
                    }}
                    disabled={!isEnablebyRole}
                  />
                </div>
                <div className='mui-custom-form input-md' />
                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='AddressLine1'
                    data-testid='Address-line'
                    label='Address Lines 1'
                    className='mandate-fields'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 50, id: 'AddressLine1' }}
                    InputLabelProps={{ shrink: true }}
                    value={maintainContractState?.otherContract?.addrLine1}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'addrLine1');
                    }}
                    disabled={!isEnablebyRole}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='AddressLine2'
                    label='Address Lines 2'
                    data-testid='address-line2'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 50, id: 'AddressLine2' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={maintainContractState?.otherContract?.addrLine2}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'addrLine2');
                    }}
                    disabled={!isEnablebyRole}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='AddressLine3'
                    label='Address Lines 3'
                    data-testid='address-lines3'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 50, id: 'AddressLine3' }}
                    InputLabelProps={{ shrink: true }}
                    value={maintainContractState.otherContract.addrLine3}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'addrLine3');
                    }}
                    disabled={!isEnablebyRole}
                  />
                </div>
                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='city'
                    data-testid='city'
                    label='City'
                    className='mandate-fields'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 30, id: 'city' }}
                    InputLabelProps={{ shrink: true }}
                    value={maintainContractState.otherContract.city}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'city');
                    }}
                    disabled={!isEnablebyRole}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='state'
                    label='State'
                    data-testid='state'
                    className='mandate-fields'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 2, id: 'state' }}
                    InputLabelProps={{ shrink: true }}
                    value={maintainContractState.otherContract.stateCd}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'stateCd');
                    }}
                    disabled={!isEnablebyRole}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <div className='row'>
                    <div className='col-sm-6 col-md-7 pr-sm-0 pr-md-2'>
                      <TextField
                        id='Zip'
                        label='Zip'
                        data-testid='zip'
                        className='mandate-fields'
                        fullWidth
                        placeholder=''
                        inputProps={{ maxLength: 10, id: 'Zip' }}
                        InputLabelProps={{ shrink: true }}
                        value={maintainContractState.otherContract.zip}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'zip');
                        }}
                        disabled={!isEnablebyRole}
                      />
                    </div>
                    <div className='col-sm-6 col-md-5 mt-md-0 pl-md-0'>
                      <TextField
                        id='Zip+4'
                        label='Zip+4'
                        data-testid='zip4'
                        className='mandate-fields'
                        fullWidth
                        placeholder=''
                        inputProps={{ maxLength: 4, id: 'Zip+4' }}
                        InputLabelProps={{ shrink: true }}
                        value={maintainContractState.otherContract.zip4}
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'zip4');
                        }}
                        onBlur={(e) => {
                          handleOnBlurEventContactTab(e, 'zip4');
                        }}
                        disabled={!isEnablebyRole}
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'zip4' &&
                                        x.tabName === 'OtherContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter((x) => {
                            return (
                              x.fieldName === 'zip4' &&
                              x.tabName === 'OtherContact'
                            );
                          }).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'zip4' &&
                                        x.tabName === 'OtherContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <div className='row'>
                    <div className='col-sm-6 col-md-7 pr-sm-0 pr-md-2'>
                      <TextField
                        id='Phone Number'
                        label={
                          windowWidth >= 745 ? 'Phone Number' : 'Phone No.'
                        }
                        data-testid='phone'
                        className='mandate-fields'
                        fullWidth
                        placeholder=''
                        inputProps={{ maxLength: 10, id: 'Phone Number' }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          maintainContractState.otherContract.phoneNum
                            ? maintainContractState.otherContract.phoneNum.trim()
                            : ''
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'phoneNum');
                        }}
                        onBlur={(e) => {
                          handleOnBlurEventContactTab(e, 'phoneNum');
                        }}
                        disabled={!isEnablebyRole}
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'phoneNum' &&
                                        x.tabName === 'OtherContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter((x) => {
                            return (
                              x.fieldName === 'phoneNum' &&
                              x.tabName === 'OtherContact'
                            );
                          }).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'phoneNum' &&
                                        x.tabName === 'OtherContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </div>
                    <div className='col-sm-6 col-md-5 mt-md-0 pl-md-0'>
                      <TextField
                        id='Extension'
                        label='Extension'
                        data-testid='Extension'
                        fullWidth
                        placeholder=''
                        inputProps={{ maxLength: 6, id: 'Extension' }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          maintainContractState.otherContract.phoneExtension
                        }
                        onChange={(e) => {
                          handleOnChangeEvent(e, 'phoneExtension');
                        }}
                        disabled={!isEnablebyRole}
                      />
                    </div>
                  </div>
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='Fax Number'
                    label='Fax Number'
                    data-testid='fax'
                    fullWidth
                    placeholder=''
                    inputProps={{ maxLength: 10, id: 'Fax Number' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={maintainContractState.otherContract.faxNum}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'faxNum');
                    }}
                    disabled={!isEnablebyRole}
                  />
                </div>
                <div className='mui-custom-form input-md'>
                  <TextField
                    id='Email Address'
                    label='Email Address'
                    data-testid='email'
                    className='mandate-fields'
                    fullWidth
                    type='text'
                    placeholder=''
                    inputProps={{ maxLength: 50, id: 'Email Address' }}
                    InputLabelProps={{ shrink: true }}
                    value={maintainContractState.otherContract.email}
                    onChange={(e) => {
                      handleOnChangeEvent(e, 'email');
                    }}
                    onBlur={(e) => {
                      handleOnBlurEventContactTab(e, 'email');
                    }}
                    disabled={!isEnablebyRole}
                    helperText={
                      errorMessagesFromRedux?.length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter((x) => {
                                  return (
                                    x.fieldName === 'email' &&
                                    x.tabName === 'OtherContact'
                                  );
                                })
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.length > 0 &&
                      errorMessagesFromRedux?.filter((x) => {
                        return (
                          x.fieldName === 'email' &&
                          x.tabName === 'OtherContact'
                        );
                      }).length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter((x) => {
                                  return (
                                    x.fieldName === 'email' &&
                                    x.tabName === 'OtherContact'
                                  );
                                })
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : false
                    }
                  />
                </div>
                <div className='line-break-div' />
                <div className='mui-custom-form input-md'>
                  <div className='comment-sec'>
                    Comments &nbsp;
                    <img
                      role='button'
                      disabled={searchContractState.contractType !== 'onSelect'}
                      onClick={() => {
                        if (searchContractState.contractType === 'onSelect') {
                          setShowComments(true);
                        }
                      }}
                      alt=' comment '
                      tabIndex={'0'}
                      onKeyDown={(e) => {
                        // Handle Enter and Space key events
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault(); // Prevents the default space scrolling behavior
                          if (searchContractState.contractType === 'onSelect') {
                            setShowComments(true);
                          }
                        }
                      }}
                      src={commentShow ? CommentVisibleIcon : CommentIcon}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </form>
      </div>
      <Dialog
        open={open}
        data-testid='close-copy-contact-popup'
        maxWidth='md'
        className='inbuilt-dialog dialogPanel custom-check dialog-600'
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'
      >
        <DialogTitle
          className='copy-contact-title'
          style={{ cursor: 'move' }}
          id='draggable-dialog-title'
        >
          <div className='float-left dialog-heading-txt mt-1'>
            Copy Contact from...
          </div>

          <div
            className='close-popup-icon float-right'
            data-testid='handle_Close'
            role='button'
            onClick={handleClose}
          >
            <img alt='' src={cancelIcon} />
          </div>
          <div className='clearfix' />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <CopyContactComponent
              Manufacturer
              setSelectedContact={setSelectedContact}
              isEnablebyRole={isEnablebyRole}
              mfgId={
                getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                  ?.mfgId
              }
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='btn-wrapper mb-2'>
            <div className='float-right hide-on-print'>
              <Button
                className='btn btn-success btn-search'
                data-testid='reset-contact-detail'
                onClick={setContactIfNotEmpty}
              >
                <SVGComponent iconName='Icon_awesome-check-circle' />
                Ok
              </Button>
              <Button
                data-testid='copy-contact-close'
                className='btn btn-cancel btn-primary'
                onClick={handleClose}
              >
                <SVGComponent iconName='Icon-cancel' />
                Cancel
              </Button>
            </div>
            <div className='clearfix' />
          </div>
        </DialogActions>
      </Dialog>
      <CommonModal
        open={showContractPop}
        viewAction
        viewHeader
        modalTitle='Show Contracts using this Contact'
        className='panel-header'
        okTitle='Ok'
        onOk={() => {
          setShowContractPop(false);
        }}
        onClose={() => {
          setShowContractPop(false);
        }}
        childrenComponent={
          <ShowContractUsingContacts
            contactSeqNum={otherContract.contactSeqNum}
          />
        }
      />
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName='CONTRACT'
          corrLinkId={maintainContractState.otherContract?.corrLinkId}
        />
      ) : null}
    </div>
  );
};
export default OtherContact;
